import { trackFullStoryEvent } from "@expert/monitoring";
import { playNotificationSound } from "@/notification/playNotificationSound";

import type { ChatMessage } from "./chatMessage";

export interface ChatEventCallbacks {
    onMessageAdded: (message: ChatMessage) => Promise<void>;
    onChatAdded: (extraData?: Record<string, unknown>) => Promise<void>;
}

export function useStatelessChatCallbacks(): ChatEventCallbacks {
    const onMessageAdded = async (message: ChatMessage) => {
        if (message.senderType === "customer") {
            await playNotificationSound("newMessage");
        }
    };

    const onChatAdded = async (extraData?: Record<string, unknown>) => {
        const eventProperties = extraData || {};

        trackFullStoryEvent("ChatAdded", eventProperties);
        const success = await playNotificationSound("newChat");
        // TODO: temporary this if-else block specifically for debugging an expert reported issue. failures are already logged in playNotificationSound
        if (success) {
            trackFullStoryEvent("NewChatNotificationPlayed", eventProperties);
        } else {
            trackFullStoryEvent("NewChatNotificationFailedToPlay", eventProperties);
        }
    };

    return { onMessageAdded, onChatAdded };
}
